// src/pages/HelpPayment.jsx
import React, { useState } from "react";
import { FaCreditCard } from "react-icons/fa";
import "./Help.css";

const FAQItem = ({ q, a, defaultOpen = false }) => {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="hp_faq_item">
      <button
        className="hp_faq_q"
        aria-expanded={open}
        onClick={() => setOpen((s) => !s)}
      >
        <span className="hp_q_text">{q}</span>
        <span className="hp_q_icon">{open ? "−" : "+"}</span>
      </button>
      <div className={`hp_faq_a ${open ? "open" : ""}`} role="region">
        <p>{a}</p>
      </div>
    </div>
  );
};

const HelpPayment = () => {
  return (
    <section className="hp_container" aria-labelledby="hp_heading">
      <header className="hp_header">
        <div className="hp_icon_wrap" aria-hidden="true">
          <FaCreditCard size={28} />
        </div>
        <div>
          <h2 id="hp_heading" className="hp_title">Payment</h2>
          <p className="hp_subtitle">
            Learn how payments, deposits, and card charges work on YOVHO.
          </p>
        </div>
      </header>

      <div className="hp_content">
        <FAQItem
          defaultOpen
          q="Which payment methods are accepted?"
          a="Most verified properties on YOVHO.com accept major credit and debit cards, such as Visa, MasterCard, and UnionPay. Some properties may also accept cash payments upon arrival. In certain cases, you might also find alternative options like local bank transfers or digital wallets, depending on the property and region. Details of accepted payment methods are always shown clearly before you confirm your booking."
        />

        <FAQItem
          q="Do I need to pay a deposit or prepayment?"
          a="Some YOVHO-verified properties may request a small prepayment or deposit to secure your booking. This amount could be part or all of your total stay cost. The remaining balance, if any, is usually paid directly at the property during check-in or check-out. Other properties may not require any prepayment at all — you’ll simply pay the full amount upon arrival. Always review the payment policy in your booking confirmation for exact details."
        />

        <FAQItem
          q="I was charged. Do I need to do anything?"
          a="Usually, no action is needed. This charge might be a prepayment or a temporary hold to confirm your booking. A test payment is simply a short-term authorization to check if your card is valid; it’s automatically released by your bank within a few days. If you believe a charge was made by mistake, please contact YOVHO Support with proof of payment, and our team will help investigate it with the property."
        />

        <FAQItem
          q="Where can I check the payment policy for my booking?"
          a="You’ll find all payment details including accepted methods, prepayment rules, and price breakdown in your confirmation email and in your YOVHO account under “My Bookings.”"
        />

        <FAQItem
          q="Why do I need to provide my card details?"
          a="Your card details are used to guarantee your booking and may also be used for prepayment if required by the property. In some cases, the property may place a temporary hold (pre-authorization) to make sure the card is active and has sufficient balance. This amount is automatically released after a short period, depending on your card provider."
        />

        <FAQItem
          q="Can I pay with a different card than the one used for booking?"
          a="Yes, most properties allow you to pay with a different card or even in cash upon arrival. However, it’s always a good idea to confirm this with the property or your YOVHO Captain in advance."
        />

        <FAQItem
          q="Who charges my card, and when?"
          a="In most cases, the property itself will charge your card during check-in or check-out. However, if a prepayment is required, you may be charged before your arrival. The exact details will always appear in your booking confirmation and payment section."
        />

        <FAQItem
          q="How can I get an invoice?"
          a="Invoices are issued directly by the property after your stay. To receive one quickly, simply request it during check-out or contact the property afterward — their contact information is included in your confirmation email."
        />
      </div>

      <footer className="hp_footer">
        <a className="hp_cta" href="/help/payment#contact-support">
          Contact YOVHO Support
        </a>
        <small className="hp_note">
          Need help with a payment issue? Call:{" "}
          <a href="tel:+923310222068">+92 331 0222068</a>
        </small>
      </footer>
    </section>
  );
};

export default HelpPayment;
